module.exports = {
  "defaultLanguage": "fr-FR",
  "languages": [
    {
      "code": "fr-FR",
      "name": "Français",
      "icon": "f711dc7c-72f3-4db3-bec3-b49cf7b5eea4.svg"
    },
    {
      "code": "en-US",
      "name": "English",
      "icon": "7ad46a1f-8fe2-442e-8fc7-59b50604f4e5.svg"
    },
    {
      "code": "de-DE",
      "name": "Deutsch",
      "icon": "8b6d2e7a-1986-47cb-87c3-8d73b581d581.svg"
    }
  ]
}